import React from 'react';
import { t } from 'ttag';

import ProductModalBackground from '@components/ProductModalBackground';
import { Select } from '@ui/Select';
import { Button } from '@ui/Button';

// style
import s from './MarkSoldModal.sss';

interface Participant {
  id: number,
  username: string,
}

export interface Thread {
  threadId: number,
  participant: Participant,
  hasBigDiscount: boolean,
  commissionPercent?: string | null,
  totalCommission?: string | null,
}

export interface Props {
  threads: Thread[],
  product: {
    id: number;
    name: string;
    img: string;
  },
  selectedThread: Thread | null,
  isSubmitting: boolean,
  onCancel: () => void,
  onSubmit: () => void,
  onSelect: (thread: Thread | null) => void,
}

export const MarkSoldModal: React.FC<Props> = ({
  threads,
  selectedThread,
  product,
  isSubmitting,
  onCancel,
  onSubmit,
  onSelect,
}) => {
  const threadCount = threads.length;
  const commissionPercent = selectedThread?.commissionPercent;

  return (
    <>
      <ProductModalBackground
        productName={product.name}
        productImg={product.img}
      />
      <div className={s.choiceBuyer}>
        <div className={s.choiceBuyerTitle}>
          {threads.length > 1
            ? t`Виберіть покупця (з ${threadCount})`
            : t`Виберіть покупця`}
        </div>
        <Select<Thread>
          isSearchable={false}
          value={selectedThread}
          options={threads}
          getOptionLabel={(option) => option.participant.username}
          getOptionValue={(option) => String(option.participant.id)}
          onChange={(thread) => onSelect(thread)}
        />

        {!!commissionPercent && (
          <>
            <p className={s.commission}>
              {t`Коли ви відмітите, що товар проданий, ми знімемо комісію ${commissionPercent} від його вартості.`}
            </p>
          </>
        )}
      </div>

      <div className={s.soldButtons}>
        <Button
          theme="secondary"
          className={s.actionButton}
          onClick={onCancel}
        >
          {t`Відміна`}
        </Button>
        <Button
          className={s.actionButton}
          onClick={onSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? t`Обробка...` : t`Вибрати`}
        </Button>
      </div>
    </>
  );
};

export default MarkSoldModal;
